import React, { Component } from "react";
import routes from "../../../../routes";
import _, { isEmpty, get, size } from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Card } from "semantic-ui-react";
import { Link } from "react-router-dom";
import successLOGO from "../../../../images/successful.png";
import PendingLogo from "../../../../images/pending.png";
import FailLogo from "../../../../images/Fail.png";
import "../AddPayment.scss";
class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleBack = () => {
    const { history } = this.props;
    history.push(
      "/" +
        routes.mainRoute +
        "/" +
        routes.containers.payment +
        "/" +
        routes.payment.billingHistory.name
    );
  };
  render() {
    const {} = this.state;
    const {
      match: {
        params: { status },
      },
    } = this.props;
    console.log(status, "Staus");
    return (
      <div style={{ "background-color": "white" }}>
        <div>
          <div className="col-md-12 ">
            {status.toLowerCase() == "pending" ? (
              <>
                <header className="pendingHeaderTag">
                  <h1>Payment Pending</h1>
                </header>

                <div className="containerSuccessDiv">
                  <div className="pendingMessage">
                    <p>Payment Pending!</p>
                  </div>

                  <img
                    className="pendingImage"
                    src={PendingLogo}
                    alt="Pending Image"
                  />

                  <p className="peraGraph">
                    Your payment is in pending state. 
                  </p>

                  <a className="anchorTagPending" onClick={this.handleBack}>
                    Return to Home
                  </a>
                </div>
              </>
            ) : status.toLowerCase() == "success" ? (
              <>
                <header className="SuccessHeaderTag">
                  <h1>Payment Success</h1>
                </header>

                <div className="containerSuccessDiv">
                  <div className="successMessage">
                    <p>Payment successful!</p>
                  </div>

                  <img
                    className="SuccessImage"
                    src={successLOGO}
                    alt="Success Image"
                  />

                  <p className="peraGraph">
                    Your payment has been successfully processed. Thank you for
                    your purchase!
                  </p>

                  <a className="anchorTag" onClick={this.handleBack}>
                    Return to Home
                  </a>
                </div>
              </>
            ) : (
              <>
                <header className="failHeaderTag">
                  <h1>Payment Failed</h1>
                </header>

                <div className="containerFailDiv">
                  <div className="failMessage">
                    <p>Payment Failed!</p>
                  </div>

                  <img className="failImage" src={FailLogo} alt="Fail Image" />

                  <p className="peraGraph">Your payment has been Failed!</p>

                  <a className="anchorTagFail" onClick={this.handleBack}>
                    Return to Home
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      tenantId: get(state, "app.preSignInState.tenantId", ""),
      userId: get(state, "app.preSignInData.userId", ""),
      authToken: get(state, "app.signInData.authToken", ""),
    }),
    {
      //  getTenantDetailsAction,
      // editInvoiceTenantAction,
      // getInvoiceDetailsListAction,
      // getTentitiveInvoiceDetailsAction
    }
  )(Invoice)
);
